export default class emptyRow {
    constructor() {
        this.row = document.createElement('tr')
    }
    render() {
        this.row.className = 'v-tr empty-row'
        return this.row
    }
}
